export type DataOption = {
    value: string | number | string[],
    text: string,
    isSelected?: boolean
}

export class InputDropdownReplacementProperties {
    data: DropdownDataOption[];
    inputSelector: any;
    dropdownId: string;
    isMultiSelect?: boolean;
    enableOtherOption?: boolean;

    constructor() {
        this.isMultiSelect = false;
        this.enableOtherOption = false;
    }
}

export type DropdownDataOption = {
    value: string | number,
    description: string
}